/*
* @Author: tengmaoqing
* @Date:   2018-04-16 20:03:46
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-05-10 10:34:58
*/

const defaultTKD = {
  title: '回收宝官网-值得信赖的手机数码回收专家',
  keywords: '手机回收,二手手机回收,平板回收,二手手机交易网',
  description: '回收宝是国内领先的二手手机数码回收平台，专注于手机回收、二手手机回收、平板回收的线上回收平台，可以在二手手机交易网快速估价，支持全国范围内手机快递回收，为用户提供安全、便捷、贴心的服务'
};

// TKD.js
function getTKD (meta, store) {
  const TKD = Object.assign({}, defaultTKD, meta);

  TKD.title = typeof TKD.title === 'function'
    ? TKD.title(meta, store)
    : TKD.title;

  TKD.keywords = typeof TKD.keywords === 'function'
    ? TKD.keywords(meta, store)
    : TKD.keywords;

  TKD.description = typeof TKD.description === 'function'
    ? TKD.description(meta, store)
    : TKD.description;

  return TKD;
}

const serverTKDMixin = (app, route, store, translate) => {
  if (!app.$ssrContext || !route) {
    return;
  }
  const TKD = getTKD(route.meta, store);
  const title = translate ? translate(TKD.title) : TKD.title;
  const keywords = translate ? translate(TKD.keywords) : TKD.keywords;
  const description = translate ? translate(TKD.description) : TKD.description;
  if (title) {
    app.$ssrContext.title = title;
  }

  if (keywords) {
    app.$ssrContext.keywords = keywords;
  }

  if (description) {
    app.$ssrContext.description = description;
  }
};

const clientTKDMixin = (app, route, store, translate) => {
  const TKD = getTKD(route.meta, store);
  if (TKD.title) {
    document.title = translate ? translate(TKD.title) : TKD.title;
    const ifr = document.createElement('iframe');
    ifr.style.display = 'none';
    ifr.src = 'https://mobile.huishoubao.com/mobile/m/oppo_service.html';
    ifr.onload = () => {
      setTimeout(() => {
        ifr.onload = null;
        document.body.removeChild(ifr);
      }, 0);
    };
    document.body.appendChild(ifr);
  }
};

export default process.env.VUE_ENV === 'server'
  ? serverTKDMixin
  : clientTKDMixin;
